export const PRE_ORDER_TAB_TYPES = {
	ACTIVE_ORDERS: 0,
	INACTIVE_ORDERS: 1
}

export default { PRE_ORDER_TAB_TYPES }
